export default "https://fiverr-res.cloudinary.com/npm-assets/@fiverr/search_perseus/financial_consulting.c8069b1.svg";